import dayjs, { Dayjs } from 'dayjs';
import { useState, useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateVisitType } from '../../../../entity';
import { useVisitsQuery } from '@features/visits/queries';
import { useHighlightedDaysQuery } from '../../../../schedule/queries';

export const useReservationCalendar = (serviceIds: string | undefined) => {
  const { setValue, control } = useFormContext<CreateVisitType>();
  const date = useWatch({ control, name: 'date' });
  const [currentMonth, setCurrentMonth] = useState(dayjs());

  const { data, isFetching } = useHighlightedDaysQuery(currentMonth.format('YYYY-MM'), serviceIds);
  //teest
  const { isLoading: visitsLoading } = useVisitsQuery({
    query: {
      from: currentMonth.startOf('month'),
      to: currentMonth.endOf('month'),
    },
  });

  const handleMonthChange = useCallback((month: Dayjs) => {
    setCurrentMonth(month);
    setValue('date', undefined);
    setValue('dateTo', undefined);
  }, []);

  const handleCalendarChange = useCallback(
    (newDate: Dayjs | null) => {
      if (newDate) {
        const d = newDate.hour(0).minute(0).second(0);
        setValue('date', d.toDate());
        setValue('dateTo', d.toDate());
      }
    },
    [setValue],
  );

  return {
    date,
    currentMonth,
    highlightedDays: data ?? {},
    isLoading: visitsLoading || isFetching,
    handleMonthChange,
    handleCalendarChange,
  };
};
